import { CORE_UPLOAD_TYPE_PERMISSIONS, CoreCsvUploadType } from './upload-types'

export const getPermissionsForCoreUploadTypes = (uploadTypes: CoreCsvUploadType[]) => {
  return uploadTypes.map((uploadType) => CORE_UPLOAD_TYPE_PERMISSIONS[uploadType])
}
